import axios from 'axios';
import { getFileNameFromAwsUrl } from '@/files';

export default async ({
  params,
  queryClient,
  update,
  videoComposeKey,
  videoPropertiesKey,
  videoVersionKey,
  handleBackendErrors,
  versionId,
}) => {
  const isInLiveMode = params.type === 'live';
  const type = isInLiveMode ? 'live_videos' : 'videos';
  const url = `/api/admin/${type}/${params.id}/properties${
    versionId ? `?version_id=${versionId}` : ''
  }`;

  const updateObject = update;

  if (update?.caption && typeof update.caption === 'string') {
    updateObject.caption = {
      url: updateObject.caption,
      name: getFileNameFromAwsUrl({ url: updateObject.caption }),
    };
  }

  if (updateObject?.topics) delete updateObject.topics;

  if (isInLiveMode && updateObject?.topic !== undefined) {
    updateObject.topic_id = updateObject.topic ? updateObject.topic.id : null;
    delete updateObject.topic;
  }

  if (isInLiveMode && updateObject?.enrollment_url !== undefined)
    delete updateObject.enrollment_url;

  try {
    await axios.put(url, { data: updateObject });
  } catch (error) {
    return handleBackendErrors(error);
  }

  if (videoComposeKey) {
    queryClient.resetQueries(videoComposeKey); // reset due to medium editor
  }

  queryClient.invalidateQueries(videoPropertiesKey);
  queryClient.invalidateQueries(videoVersionKey);
};
